import { observable, action} from 'mobx';
import axios from 'axios'
import { browserName, fullBrowserVersion, osName } from 'react-device-detect';

import { apiUrl } from '../../config'

class LoginFromStore {
  @observable isLoggedIn = localStorage.getItem('PHPSESSID') ? true :false
  @observable errorMsg = ''
  @observable codeSended = false
  @observable codeSendedTime = 0
  @observable timer = null
  @observable clientPhone = ''
  @observable clientInfo = localStorage.getItem('clienInfo') ? JSON.parse(localStorage.getItem('clienInfo')) : null

  getMyInfo = login => {
    
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    axios.get(`${apiUrl}templateAll.php?func=loadMyInfo`, {
      params: {
        phone: login.trim(),
        PHPSESSID: PHPSESSID,
      }
    })
    .then( infoResult => {
      if(infoResult.data[0]){
        this.clientInfo = {...infoResult.data[0]}
        localStorage.setItem('clienInfo', JSON.stringify(infoResult.data[0]))
  
        this.isLoggedIn = true
      } else {
        localStorage.removeItem('clienInfo')
        localStorage.removeItem('PHPSESSID')
        this.isLoggedIn = false
      }
    })
    .catch( errs => {
      console.log(errs)
    })
  }


  @action
  tryAuth = (login, password) => {

    axios.get(`${apiUrl}reglogand.php?func=LoginToken`,{
      params: {
        login: login,
        password: password,
        device: browserName,
        version: fullBrowserVersion,
        os: osName
      }
    })
      .then( async response => {
        if(response.data.message === 'limitSendSMS'){
          this.errorMsg = 'Достигнут лимит запросов на отправку сообщений'
        } else if (response.data.message === 'block'){
          this.errorMsg = `Извините, но номер телефона +${login} находится в черном списке! Свяжитесь пожалуйста с Администрацией по телефону 0445373536 (с 10 до 18 пн-пт).`
        } else if(response.data.message === 'success'){
          localStorage.setItem('PHPSESSID', response.data.session)
          await this.getMyInfo(login)
          
          this.errorMsg = ''
          this.clientPhone = login

        }else {
          this.errorMsg = 'Непредвиденная ошибка'
        }
      })
      .catch( err => {
        this.errorMsg = `Ошибка: ${err}`
      })
  }

  /* */
  getCode = phone => {
    axios.get(`${apiUrl}reglogand.php?func=code&tel=${phone}`)
      .then( response => {
        if(response.data.message === 'limitSendSMS'){
          this.errorMsg = 'Достигнут лимит запросов на отправку сообщений'
        } else if(response.data.message === 'block'){
          this.errorMsg = `Извините, но номер телефона +${phone} находится в черном списке! Свяжитесь пожалуйста с Администрацией по телефону 0445373536 (с 10 до 18 пн-пт).`
        } else {
          this.errorMsg = false
          this.codeSended = true
          this.codeSendedTime = 60
          this.timer = setInterval( () => { if(this.timer < 1) {clearInterval(this.timer)} else {this.codeSendedTime--} }, 1000)
        }
      })
      .catch( err => {
        this.errorMsg = `Ошибка: ${err}`
      })
  }

  logout = () => {
    localStorage.removeItem('PHPSESID')
    this.isLoggedIn = false
  }
}

export default new LoginFromStore();